/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BloodManagementReactionAliases {
  APPLY_FILTER_BUTTON = 'apply-filter-button',
  AUTOCOMPLETE = 'autocomplete',
  AUTOCOMPLETE_REASON_LIST = 'autocomplete-reason-list',
  CHECKBOX_DENIES_REACTION = 'checkbox-denies-reaction',
  CLEAR_FILTER_BUTTON = 'clear-filter-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  CONTEXTUAL_BAR_TITLE = 'contextual-bar-title',
  FETCH = 'fetch',
  FETCH_REASON = 'fetch-reason',
  FIELD = 'field',
  FIELD_DENIES_REACTION = 'field-denies-reaction',
  FIELD_REASON = 'field-reason',
  FIELD_SYMPTOMS = 'field-symptoms',
  FILTER = 'filter',
  FILTERED_LIST = 'filtered-list',
  FORM_REACTION = 'form-reaction',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  FRAGMENT_REFERENCE_MEDICATION_AND_DATE = 'fragment-reference-medication-and-date',
  MAIN_PANEL = 'main-panel',
  MAPPER = 'mapper',
  MAPPER_REASON = 'mapper-reason',
  PANEL_BUTTON_APPLY = 'panel-button-apply',
  PANEL_BUTTON_CLEAR = 'panel-button-clear',
  PANEL_BUTTONS = 'panel-buttons',
  REACTION_LAYOUT = 'reaction-layout',
  TEXT = 'text',
  TEXT_AREA_SYMPTOMS = 'text-area-symptoms',
  TEXT_REASON = 'text-reason',
}
export { BloodManagementReactionAliases };
